import Validator from '../../utils/Validator';
import Utils from '../../utils/Utils';
import ClientDialog from './ClientDialog';

/**
 * copy to clipboard confirmation dialog class
 */
export default class CpyClpCfd extends ClientDialog {

	/**
	 * constructs a new instance
	 * @param {String} data data string to be copied to the clipboard
	 * @param {*} ico icon descriptor
	 * @param {*} par additional parameters
	 */
	constructor(data, ico, par) {
		super('gui.misc.CpyClpCfd', ico, par);
		this.dataElm = null;
		this.copyMsg = par.msg || '';
		this.clpData = data || '';
	}

    /**
     * @override
     */
	doDestroy() {
		super.doDestroy();
		delete this.copyMsg;
		delete this.dataElm;
	}

	/**
	 * @override
	 */
	show() {
		super.show()
		if ( this.dataElm ) {
			this.dataElm.focus();
			this.dataElm.select();
			this.dataElm.scrollLeft = 0;
		}
	}

	/**
	 * @override
     * @param {HTMLElement} hdr_frame the header frame
     * @param {HTMLElement} body_frame the body frame
     * @param {HTMLElement} btn_frame  the button frame
	 */
	renderDlg(hdr_frame, body_frame, btn_frame) {
		const par = this.dlgPar;
		// create input element providing data to be copied to the clipboard
		const inp = document.createElement('input');
		inp.className = 'dlgdata';
		inp.readOnly = true;
		inp.value = '' + this.clpData;
		body_frame.appendChild(inp);
		this.dataElm = inp;
		// create the "Copy" button
		const btn_copy = document.createElement('div');
		btn_copy.classList.add('dlgbtn');
		btn_copy.classList.add('dlgbigbtn');
		btn_copy.innerHTML = Utils.escHtml(par.btx || 'Copy');
		if ( Validator.isString(par.btp) ) {
			btn_copy.title = par.btp;
		}
		btn_frame.appendChild(btn_copy);
		// attach listener
		const self = this;
		btn_copy.addEventListener('click', () => {
			self._onCopy();
		});
	}

	/**
	 * @override
	 */
	onEnter() {
		this._onCopy();
	}

	/**
	 * copies the text to the clipboard, creates a confirmation message and closes the dialog
	 */
	_onCopy() {
		if ( this.dataElm ) {
			// select all text in the input element
			this.dataElm.focus();
			this.dataElm.select();
			this.dataElm.scrollLeft = 0;
			// old style and deprecated but still supported :-)
			document.execCommand('copy');
			// show a floating message to the user
			if ( Validator.isString(this.copyMsg) ) {
				if ( pisasales.cliCbkWdg ) {
					pisasales.cliCbkWdg.shwFloMsg( { txt: this.copyMsg, ico: null, fntico: '<i class="fa fa-info"></i>' } );
				}
			}
		}
		this.close();
	}

};
